// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

export const BL = {
  protocol: 'https://',
  emailValidation: '/api/bff/example/email',
  tokenValidation: '/api/bff/authentication/verifyGoogleSecurityToken',
  getRolesBasePath: '/authorization-service/authorization/roles',
  getLatamCrew: '/api/bl/v1/crewinfo/latam-crew',
  validateLatamCrew: '/api/bl/v1/crewinfo/latam-crew/validate',
  getTickets: '/api/bl/v1/tickets',
  getAirportsBr: '/api/bl/v1/airports?isoCountryCode=BR',
  getFlights: '/api/bl/v1/flights',
  getSeatCounts: '/api/bl/v1/flights/seat-counts',
  newTicketLatamCrew: '/api/bl/v1/tickets/latam-crew/new',
  newTicketExternalCrew: '/api/bl/v1/tickets/external-crew/new',
  cancelTicket: '/api/bl/v1/tickets/cancel',
  siteVerify: '/authorization-service/google/siteverify',
  changeBp: '/api/bl/v1/crewinfo/change-bp',
  getCrewByBpTest: '/api/bl/v1/crewinfo/latam-crew',
  externalCrewValidate: '/authorization-service/authorization/external-crew/validate',
  externalCrewUpdate: '/authorization-service/authorization/external-crew/update',
  externalCrewResetPassword: '/authorization-service/authorization/external-crew/reset-psw',
  externalCrewSendEmailCode: '/authorization-service/authorization/external-crew/send-email-code',
  externalCrewValidateEmailCode: '/authorization-service/authorization/external-crew/validate-email-code'
};

export const configProperties = {
  configPath: 'assets/config/app.config.json'
}
